import { computed, inject, Injectable, signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { WidgetStructureObject } from '../../api/interfaces';
import { CompilingFormService } from './compiling-form.service';
import { CompilingPointsService } from './compiling-points.service';
import { FormRulesService } from '../rules/form-rules.service';

@Injectable()
export class CompilingWidgetService<T = unknown, C = unknown> {
  private readonly forms = inject(CompilingFormService);
  private readonly rules = inject(FormRulesService);
  private readonly points = inject(CompilingPointsService);
  private readonly _uniqueId = signal<string | undefined>(undefined);

  get uniqueId(): string | undefined {
    return this._uniqueId();
  }

  set uniqueId(uniqueId: string) {
    this._uniqueId.set(uniqueId);
  }

  widget = computed(() => {
    const id = this._uniqueId();
    if (!id) return undefined;

    const module = this.forms.moduleStructure();
    if (!module) return undefined;

    return module[id] as WidgetStructureObject<T>;
  });

  formControl = computed<FormControl<C> | undefined>(() => {
    const id = this._uniqueId();
    if (!id) return undefined;

    return this.forms.form.controls[id] as FormControl<C>;
  });

  visible = this.rules.isVisible(this._uniqueId);

  readonly maxPoints = computed(() => {
    const uniqueId = this._uniqueId();
    if (!uniqueId) return 0;
    return this.points.getMaxPointsForWidget(uniqueId)();
  });
}
